export enum ProductTypesEnum {
  PERSONAL_LOAN = 1,
  HOME_LOAN = 2,
  CAR_LOAN = 3,
  CREDIT_CARD = 4,
  PREPAID_CARD = 5,
  CERTIFICATE_DEPOSIT = 6,
  TIME_DEPOSIT = 7,
}
